import { FC } from "react";
import {
  InspectionStatus,
  inspectionStatusLabel,
} from "enums/InspectionStatus.enum";
import { cn } from "helpers/classNames";

interface Props {
  status: InspectionStatus;
  className?: string;
}

const containerBaseClass =
  "inline-flex items-center gap-x-0.5 rounded-md pl-1.5 pr-2 py-1 text-xs font-medium ring-1 ring-inset";

export const InspectionStatusTag: FC<Props> = ({ status }) => (
  <span className={cn(containerBaseClass, getContainerClass(status))}>
    {inspectionStatusLabel(status)}
  </span>
);

export const getContainerClass = (status: InspectionStatus) => {
  switch (status) {
    case InspectionStatus.MissingSeparatorData:
      return "bg-yellow-50 text-yellow-900 ring-yellow-600/20";
    case InspectionStatus.Created:
      return "bg-gray-50 text-gray-900 ring-gray-600/20";
    case InspectionStatus.Started:
      return "bg-blue-50 text-blue-900 ring-blue-600/20";
    case InspectionStatus.RequirementsFulfilled:
      return "bg-cyan-50 text-cyan-900 ring-cyan-600/20";
  }
};
